import { deleteModel, findModelMulti, updateModel } from "@/api/project/model";
import { Model } from "@/commons/interface/project/model";
import TnModal from "@/commons/widget/base-modal";
import TnMessage from "@/commons/widget/message";
import { Modal, message } from "antd";
import classNames from "classnames";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as ShowSvg } from './icons/show.svg';
import { ContextMenuFC } from "tncet-common";
import TnInput from "@/commons/widget/input/tn-input";
import { ReactComponent as AddSvg } from './icons/add.svg';
import genUUID from "@/commons/utils/gen-uuid";
import { Branch } from "@/commons/interface/project/branch";
import { createBranch } from "@/api/project/branch";
import { ReactComponent as OpenSvg } from './icons/open.svg';
import { ReactComponent as CloseSvg } from './icons/close.svg';
import BranchItem from "./branch-item";
import { graphicStore } from "@/commons/store/graphic-store";
import { findPrimitiveUuidsInGraphicByTypes, findPrimitivesInGraphicByTypes, updatePrimitivesModel } from "@/api/geometry/primitive";
import { ReactComponent as MoveSvg } from './icons/move.svg';
import { Primitive } from "@/commons/interface/geometry/primitive";
import { ModelBase } from "pytha";
import { SystemStatus } from "@/commons/context/system-store";
import { SystemContext } from "@/App";
import { ModelType } from "@/commons/enums/model-file-type";

interface Iprops {
    model: Model // 模型
    // isShow: boolean // 显示
    onDeleteModel: () => void // 删除了模型
    onUpdateModel: (data: Model) => void // 更新了模型
    // togglePreview: (modelUuid) => void // 显示/隐藏模型
    className?: string; // 添加 className 属性，允许外部传入样式类
}

export default function ModelItem(props: Iprops) {
    const { projectUuid, modelUuid, branchUuid } = useParams();
    const { model, className } = props;
    const [isShow, setIsShow] = useState<boolean>(false); // 是否预览
    const itemClasses = classNames("model-item", className); // 动态合并样式名称
    const [item, setItem] = useState<Model>();
    const [modelCmOpen, setModelCmOpen] = useState<boolean>(false); // 是否展开模型的右键菜单
    const [top, setTop] = useState<number>(); // 右键菜单top
    const [left, setLeft] = useState<number>(); // 右键菜单left
    const navigate = useNavigate();
    const [editing, setEditing] = useState<boolean>(false); // 是否处于编辑状态
    const [adding, setAdding] = useState<boolean>(false); // 正在添加分支
    const [addName, setAddName] = useState<string>(''); // 添加的分支的名字
    const systemContext = useContext<SystemStatus>(SystemContext);

    useEffect(() => {
        setItem(model);
    }, [model])

    useEffect(() => {
        if (modelUuid == item?.uuid && !branchUuid) {
            setIsShow(true);
        }
    }, [modelUuid, item])

    const open = () => {
        setIsShow(true);
        const editor = graphicStore.extraContext.getCurrentViewEditor();
        if (!editor) return;
        // 展示该模型的图元
        needShowOpe().then(res => {
            if (!!res) {
                message.loading(`正在加载图元...`, 0);
                findPrimitivesInGraphicByTypes(projectUuid, { types: ['HoleT', 'DoorT', 'WindowT'], modelUuid: item.uuid, notBranchUuid: branchUuid })
                    .then((res) => {
                        let jsonList: Primitive[] = res.data || [];
                        let entities = [];
                        jsonList.forEach((json: Primitive) => {
                            if (editor.entityDict[json.uuid]) return;
                            let entity: ModelBase = new (graphicStore.context.modelContext.getModelConstructor(json.properties.type))();
                            entity.fromJson(json.properties);
                            entity.lock = true;
                            entities.push(entity);
                        });
                        editor.addObjects(entities);
                        return findPrimitivesInGraphicByTypes(projectUuid, { notTypes: ['HoleT', 'DoorT', 'WindowT'], modelUuid: item.uuid, notBranchUuid: branchUuid })
                    }).then((res) => {
                        let jsonList: Primitive[] = res.data || [];
                        let entities = [];
                        jsonList.forEach((json: Primitive) => {
                            if (editor.entityDict[json.uuid]) return;
                            let entity: ModelBase = new (graphicStore.context.modelContext.getModelConstructor(json.properties.type))();
                            entity.fromJson(json.properties);
                            entity.lock = true;
                            entities.push(entity);
                        });
                        editor.addObjects(entities);
                        message.destroy();
                        message.success("加载成功");
                    }).catch((err) => {
                        message.destroy();
                        message.error("加载失败");
                    })
            }
        })
    }

    const hidden = () => {
        setIsShow(false);
        const editor = graphicStore.extraContext.getCurrentViewEditor();
        if (!editor) return;
        needShowOpe().then(res => {
            if (!!res) {
                // 不展示该模型的图元
                let notModelUuid = item.uuid != modelUuid ? modelUuid : null
                findPrimitiveUuidsInGraphicByTypes(projectUuid, { modelUuid: item.uuid, notModelUuid: notModelUuid, notBranchUuid: branchUuid }).then(res => {
                    let uuids = res.data || [];
                    editor.removeObjectByUuids(uuids);
                })
            }
        })
    }

    const needShowOpe = async () => {
        try {
            const res = await findModelMulti([modelUuid, item.uuid]);
            // 查询 移动后的model和当前model 比较是否同一楼栋且是否都显示，都显示的话就不用去掉
            let modelList = res.data || [];
            if (modelList.length !== 2) return true;
            let isZero = modelList[0].uuid === modelUuid;
            const currentModel = modelList[isZero ? 0 : 1];
            const targetModel = modelList[isZero ? 1 : 0];

            // 原本不是建筑、目标不是结构、两个模型不在同一楼栋 那么需要操作
            if (currentModel.type !== ModelType.ARCHITECTURE || targetModel.type !== ModelType.STRUCTURE ||
                currentModel?.buildingUuid !== targetModel?.buildingUuid || !!branchUuid) {
                return true;
            }
            return false;
        } catch (err) {
            return true; // 如果出错，默认返回 true
        }
    };

    // 点击了展开收起
    const handleExpandItem = () => {
        if (editing) return;
        setItem({ ...item, expanded: !item.expanded });
    }

    useEffect(() => {
        if (systemContext.onlyShowModelUuid != null && systemContext.onlyShowModelUuid != item?.uuid) {
            setIsShow(false);
        }
    }, [systemContext.onlyShowModelUuid])

    // 打开模型
    const openModel = (e) => {
        if (editing) return;
        if (!item) return;
        if (item.uuid == modelUuid && !branchUuid) return;
        // props.onCloseOther(item.uuid);
        systemContext.setOnlyShowModelUuid(item.uuid);
        e.stopPropagation();
        setItem({ ...item, expanded: true });
        navigate(`/project/${item.projectUuid}/model/${item.uuid}`);
        systemContext.setCurrentBranchUuid(null);
    }


    // 右键模型
    const onRightClickModel = (e) => {
        setModelCmOpen(true);
        setLeft(e.clientX);
        setTop(e.clientY);
    }

    // 更新模型
    const onUpdateModel = (uuid: string, data) => {
        updateModel(uuid, data).then(res => {
            setItem({ ...item, ...data });
            props.onUpdateModel({ ...item, ...data, expanded: true })
        })
    }

    // 删除模型
    const onDeleteModel = () => {
        if (!item) return;
        if (item.origin) {
            TnMessage.warning("根模型不能删除");
            return;
        }
        if (item.uuid == modelUuid) {
            TnMessage.warning("当前模型不能删除");
            return;
        }
        TnModal().deleteModal({
            onOk() {
                Modal.destroyAll();
                let removeEntityUuids = [];
                if (isShow) {
                    findPrimitiveUuidsInGraphicByTypes(projectUuid, { modelUuid: item.uuid }).then(res => {
                        removeEntityUuids = res.data || [];
                        confirmDeleteModel(item, removeEntityUuids);
                    })
                } else {
                    confirmDeleteModel(item, removeEntityUuids);
                }
            },
            onCancel() {
                Modal.destroyAll();
            },
            content: `点击确认，删除${item.name}，并删除模型中的所有图元`,
            closable: true
        })
    }

    // 删除模型
    const confirmDeleteModel = (item, removeEntityUuids) => {
        deleteModel(item.uuid).then(res => {
            TnMessage.success("删除成功");
            let newPreview = [...systemContext.showModelUuidList];
            let pidx = newPreview?.findIndex(uuid => uuid === item.uuid);
            if (pidx !== -1) {
                newPreview.splice(pidx, 1);
                // 不展示该模型的图元
                const editor = graphicStore.extraContext.getCurrentViewEditor();
                if (editor) {
                    editor.removeObjectByUuids(removeEntityUuids);
                }
                systemContext.setShowModelUuidListValue([...newPreview]);
            }
            props.onDeleteModel();
        }).catch(() => {
            TnMessage.error("删除失败")
        })
    }

    // 点击了添加分支
    const onClickAddBranch = () => {
        // 模型没展开时，展开
        if (!item.expanded) {
            setItem({ ...item, expanded: true });
        }
        if (adding) return;
        setAdding(true);
        setAddName("");
    }

    // 添加分支
    const onAddBranchSave = () => {
        if (!addName || addName?.trim()?.length === 0) {
            setAdding(false);
            setAddName("");
            return;
        }
        let uuid = genUUID();
        let branch: Branch = {
            uuid: uuid,
            projectUuid: item.projectUuid,
            modelUuid: item.uuid,
            name: addName,
        }
        createBranch(branch).then(res => {
            if (res.status === 200) {
                let branchId = res.data;
                if (item.branchList == null) {
                    item.branchList = [];
                }
                item.branchList.push({ ...branch, id: branchId });
                setItem({ ...item });
                props.onUpdateModel({ ...item });
                TnMessage.success("添加成功");
                setAdding(false);
                setAddName("");
            }
        }).catch(err => {
            TnMessage.error("添加失败");
        })
    }

    // 显示/不显示模型
    const togglePreview = () => {
        if (modelUuid == item.uuid && !branchUuid) return;
        // props.togglePreview(item.uuid);
        if (isShow) {
            hidden();
        } else {
            open();
        }
    }

    // 将选中的图元移动到该模型里
    const moveModelPrimitives = (model: Model) => {
        if (!model || model?.uuid === modelUuid) return;
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        let editor = graphicStore?.extraContext?.getCurrentViewEditor();
        // 选中图元
        let selected = editor.selectControl.getSelectedEntityList().filter(item => !item.lock);
        if (selected?.length === 0) {
            TnMessage.info("未选中图元");
            return;
        }
        let primitiveUuids = selected?.map(i => i.uuid);
        message.loading(`正在移动图元至${model?.name}...`, 0);
        updatePrimitivesModel(primitiveUuids, projectUuid, model?.uuid).then(res => {
            if (res.status === 200) {
                message.destroy();
                message.success("移动成功");
                needShowOpe().then(res => {
                    if (!!res) {
                        editor.removeObjectByUuids(primitiveUuids);
                    } else {
                        editor.selectControl.resetSelectedEntities();
                    }
                })

                // findModelMulti([modelUuid, model.uuid]).then(res => {
                //     // 查询 移动后的model和当前model 比较是否同一楼栋且是否都显示，都显示的话就不用去掉
                //     let modelList = res.data || [];
                //     if (modelList.length !== 2) {
                //         message.error("获取模型信息失败");
                //         editor.removeObjectByUuids(primitiveUuids);
                //         return;
                //     }
                //     let isZero = modelList[0].uuid === modelUuid;
                //     const currentModel: Model = modelList[isZero ? 0 : 1];
                //     const targetModel: Model = modelList[isZero ? 1 : 0];
                //     // 原本不是建筑、目标不是结构、两个模型不在同一楼栋 那么需要移除
                //     console.log(currentModel.type !== ModelType.ARCHITECTURE, targetModel.type !== ModelType.STRUCTURE, currentModel?.buildingUuid !== targetModel?.buildingUuid);
                //     if (currentModel.type !== ModelType.ARCHITECTURE || targetModel.type !== ModelType.STRUCTURE ||
                //         currentModel?.buildingUuid !== targetModel?.buildingUuid) {
                //         editor.removeObjectByUuids(primitiveUuids);
                //         return;
                //     }
                //     editor.selectControl.resetSelectedEntities();
                // }).catch(err => {
                //     message.error("获取模型信息失败");
                //     // 现有模型中去掉这些图元
                //     editor.removeObjectByUuids(primitiveUuids);
                // })
                // systemContext.showModelUuidList
                // editor.removeObjectByUuids(primitiveUuids);
            }
        }).catch(err => {
            console.log('err', err)
            message.destroy();
            message.error("移动失败");
        })
    }

    if (!item) {
        return (<div></div>)
    }

    return (
        <div className={itemClasses}>
            <div className={classNames({
                "model-title": true,
                "selected": modelUuid == item.uuid && !branchUuid,
            })} onClick={openModel} onContextMenu={(e) => { e.preventDefault(); onRightClickModel(e) }}>
                {editing && <TnInput
                    className="small-input"
                    defaultValue={item.name}
                    onBlur={(value) => {
                        onUpdateModel(item.uuid, { name: value })
                        setEditing(false);
                    }}
                    onEscapeKeyDown={() => {
                        setEditing(false);
                    }}
                    onPressEnter={(value) => {
                        onUpdateModel(item.uuid, { name: value })
                        setEditing(false);
                    }}
                />}
                {!editing && (
                    <>
                        <div className="preview-icon" >
                            <ShowSvg className={classNames({
                                "arrow-icon": true,
                                "expanded": item.expanded
                            })} onClick={(e) => { e.stopPropagation(); handleExpandItem() }} />
                        </div>
                        <div className="preview-icon" onClick={(e) => { e.stopPropagation(); togglePreview() }}>
                            {!isShow && <CloseSvg />}
                            {isShow && <OpenSvg />}
                        </div>
                        <div className="name">
                            <span>{item.name}</span>
                        </div>
                        <div title="移动到该模型" className="move-icon" onClick={(e) => { e.stopPropagation(); moveModelPrimitives(item) }}>
                            {modelUuid != item.uuid && (
                                <MoveSvg />
                            )}
                        </div>
                        <div className="add-branch-btn" onClick={(e) => {
                            e.stopPropagation();
                            onClickAddBranch();
                        }}><AddSvg />分支</div>
                    </>
                )}
            </div>
            {item.expanded && (
                <div className="branch-list">
                    {(item.branchList || []).map((branch, idx) => (
                        <BranchItem
                            key={idx}
                            branch={branch}
                            onUpdateBranch={data => {
                                let newBranch = { ...branch, ...data };
                                item.branchList.splice(idx, 1, newBranch);
                                setItem({ ...item })
                                props.onUpdateModel({ ...item });
                            }}
                            onDeleteBranch={() => {
                                item.branchList.splice(idx, 1);
                                setItem({ ...item })
                            }}
                        />
                    ))}
                    {adding && (
                        <div className="branch-item">
                            <TnInput
                                value={addName}
                                onTextChange={(value) => setAddName(value)}
                                onPressEnter={onAddBranchSave}
                                onEscapeKeyDown={() => {
                                    setAdding(false);
                                    setAddName("");
                                }}
                                onBlur={onAddBranchSave}
                                placeholder='输入分支名称'
                                autoFocus
                            />
                        </div>
                    )}
                </div>
            )}
            <ContextMenuFC
                visible={modelCmOpen}
                top={top}
                left={left}
                width={64}
                wrapperClassname='tn-right-context-menu model-panel'
                onCancel={() => { setModelCmOpen(false) }}
            >
                <div className="menu-item" onClick={() => { setEditing(true); setModelCmOpen(false) }}>重命名</div>
                <div className="menu-item" onClick={() => { setModelCmOpen(false) }}>复制</div>
                <div className="menu-item" style={{ color: '#DE0000' }} onClick={() => { onDeleteModel(); setModelCmOpen(false) }}>删除</div>
                <div className="menu-item model-detail" onClick={() => { setModelCmOpen(false) }}>查看详情</div>
            </ContextMenuFC>
        </div>
    )
}